import { useEffect, useState, type ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import AdminLogin from './AdminLogin';
import AdminDashboard from './AdminDashboard';
import { getAdminSession } from '../lib/api';

type Status = 'checking' | 'ok' | 'down';
type Props = { backendStatus: Status };

export default function Landing({ backendStatus }: Props) {
  const [session, setSession] = useState<boolean | null>(null);
  const [configured, setConfigured] = useState(true);
  useEffect(() => { getAdminSession().then((data) => { setSession(data.ok); setConfigured(data.configured); }).catch(() => setSession(false)); }, []);
  if (session === null) return <div className="loading-screen">正在检查后台权限…</div>;
  if (!configured && !session) return <AdminLogin onSuccess={() => setSession(true)} />;
  if (!session) return <AdminLogin onSuccess={() => setSession(true)} />;
  return <AdminDashboard backendStatus={backendStatus} onLogout={() => setSession(false)} />;
}

export function AdminGate({ children }: { children: ReactNode }) {
  const [session, setSession] = useState<boolean | null>(null);
  useEffect(() => { getAdminSession().then((data) => setSession(data.ok)).catch(() => setSession(false)); }, []);
  if (session === null) return <div className="loading-screen">正在检查后台权限…</div>;
  if (!session) return <Navigate to="/" replace />;
  return <>{children}</>;
}
